module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_qualify_banner_variant4_image-6092352d50119cfe3a431cbb25d55855.jpg";